export const SourceErrors = {
	DUPLICATE: 'duplicate',
	INVALID_URL: 'invalid-url',
	UNSUPPORTED_URL: 'unsupported-url',
	CURRENT_CONTENT: 'current-content',
} as const;
export type SourceError = (typeof SourceErrors)[keyof typeof SourceErrors];
